import { Checkbox, ListItem, ListItemText } from '@material-ui/core';
import * as React from 'react';
import Version from 'src/new/versions/Version';
import './VersionListItem.css';

interface Props {
    version: Version;
    isSelected: boolean;
    onSelectedChange: (version: Version, isSelected: boolean, isShiftKeyDown: boolean) => void;
}

export default class VersionListItem extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    public render(): React.ReactNode {
        return (
            <ListItem
                className="VersionListItem"
                button={true}
                dense={true}
                disableRipple={true}
                onClick={this.handleClick}>
                    <ListItemText
                        className="VersionListItem_Text"
                        title={this.props.version.getCode() + ' - ' + this.props.version.getName()}
                        primaryTypographyProps={{ noWrap: true, display: 'block' }}>
                        {this.props.version.getName()}
                    </ListItemText>
                    <Checkbox
                        className="VersionListItem_TickBox"
                        checked={this.props.isSelected} />
            </ListItem>
        );
    }

    private handleClick(event: React.MouseEvent<HTMLElement, MouseEvent>): void {
        this.props.onSelectedChange(this.props.version, !this.props.isSelected, event.shiftKey);
    }
}
